import React, { useState, useEffect } from "react";
import SubHeader from "../staffSignUp/components/subHeader";
// import img from "../../assets/images/3-3.png";
import img from "../../assets/images/3-4.svg.svg";
import { callApi } from "../../../redux/action/action";
import ErrorState from "../staffSignUp/components/errorState";
import Pending from "../../modals/pending";
import { CometChat } from "@cometchat-pro/chat";
import { useHistory } from "react-router-dom";
import Loader from "../../modals/Loader";
import { showSuccessToast } from "../../common/toastMeassage/ToastMeassage";
import { HeaderComp } from "../staffSignUp/headerComp";
import logoText from "../../assets/images/logoText.svg";
import logo from "../../assets/images/brandIcon.svg";
import Button from "../../ui/Button";
const HospSignUp_3 = (props) => {
  const [userName, setUserName] = useState("William");
  const [agreement, setAgreement] = useState(false);
  const [error, setError] = useState(false);
  const [showAlert, setShowAlert] = useState("none");
  const [showPending, setShowPending] = useState("none");
  const [mm, setMm] = useState("");
  const [yy, setYy] = useState("");
  const [dd, setDd] = useState("");
  const [month, setMonth] = useState("");
  const [date, setDate] = useState("");
  const [locations, setLocations] = useState("");
  const [after_date, setAfterDate] = useState("th");
  const [showLoader, setShowLoader] = useState(false);
  const history = useHistory();
  const { fullName } = props;
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
   const {  hosZipcode, hosCity, hosState, hosAddress } = props;

    window.scrollTo({ top: 0, behavior: "smooth" });
    var date = new Date();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var dat = date.getDate();
    var after_date = "th";
    if (dat === 1 || dat === 21 || dat === 31) {
      after_date = "st";
    } else if (dat === 2 || dat === 22) {
      after_date = "nd";
    }
    setAfterDate(after_date);
    var mm = date.getMonth() + 1;
    var currentMonth = months[mm - 1];
    var yy = date.getFullYear();
    var dd = dat < 10 ? "0" + dat : dat;
    mm = mm < 10 ? "0" + mm : mm;

    setMm(mm);
    setYy(yy);
    setDd(dd);
    setMonth(currentMonth);
    setDate(dat);
   const loc = `${hosAddress} street, ${hosCity}, ${hosState}, ${hosZipcode}`;
    setLocations(loc);
    // setUserName(`${hosFirstname} ${hosLastName}`);
  };

  const finishSignUp = async () => {
    var hosFirstname = window.localStorage.getItem("first_name");
    var hosLastName = window.localStorage.getItem("last_name");
    var hosEmail = window.localStorage.getItem("email");
    var hosPhone = window.localStorage.getItem("phone");
    var hosPassword = window.localStorage.getItem("password");
    var hosRepassword = window.localStorage.getItem("repassword");
    var hosRole = window.localStorage.getItem("role");
    var hosEin = window.localStorage.getItem("ein");
    var hosInstiName = window.localStorage.getItem("institution_name");
    var hosInstiSize = window.localStorage.getItem("institution_size");
    var hosInstiWeb = window.localStorage.getItem("institution_website");
    var hosZipcode = window.localStorage.getItem("zip_code");
    var hosCity = window.localStorage.getItem("hoscity");
    var hosState = window.localStorage.getItem("hosstate");
    var hosAddress = window.localStorage.getItem("hosstreet_address");

    if (agreement) {
      setShowPending("block");
      setShowLoader(true);

      var data = {
        name: `${hosFirstname} ${hosLastName}`,
        email: hosEmail,
        hiringRole: hosRole,
        healthCareInstitution: {
          name: hosInstiName,
          size: hosInstiSize,
          website: hosInstiWeb,
        },
        corporateAddress: {
          zipCode: hosZipcode,
          street: hosAddress,
          city: hosCity,
          state: hosState,
        },
        password: hosPassword,
        phone: hosPhone,
        avatar: "",
        badge: true,
        ein: hosEin,
      };

      var res = await callApi("POST", "v1/LHS/hospital/signup", null, data);
      setTimeout(() => {
        setShowLoader(false);
      }, 1000);
      if (res && res.data && res.data._id) {
        /* CometChat SignUp */
        // props.onFormSubmit();
        showSuccessToast("Hospital created successfully");

        history.push("/login");
      } else {
        console.error("Error in API response:", res);
      }
      setShowPending("none");
    } else {
      setShowAlert("block");
    }
  };

  const handleBack = () => {
    history.push("/hospSignUp_2");
  };
  return (
    <div className="d-flex h-screen overflow-hidden">
      <div className="flex justify-between items-center w-full px-4">
        <div className="ssu_container py-4 px-0 md:!px-5 max-h-[90vh] h-auto w-full">
          <div className=" mt-3   w-full flex flex-col justify-center items-center  ">
            <div className="ssu_txt1 space-y-4 ">
              <div className="flex items-center justify-center  gap-2  md:gap-4">
                <img alt="img" src={logo} className="brandLogo" />
                <img alt="img" src={logoText} className="logInLogo" />
              </div>
              <p className="font-inter font-semibold  md:text-3xl ">
              Hospital Staffing Agreement
              </p>
            </div>

            <div className="ssu_txt1 text-lg mt-2 md:mt-3 mb-0 text-center">
              Please go through the agreement and provide your consent
            </div>

            <div className="ssu4_text3 !text-base w-full  md:w-[75%] space-y-4  max-w-[840px]">
              <p>
                 This Agreement entered into this {date + after_date} day of{" "}
                {month}, {yy} (“Effective Date – {mm}/{dd}/{yy}”), by and
                between LINKHEALTHSTAFF LLC (“LHS”), a Nevada registered
                corporation, and CLIENT located at {locations} WHEREAS, LHS
                operates an on-demand healthcare staffing platform that
                facilitates meeting and hiring of healthcare personnel to
                provide services to CLIENT. WHEREAS, CLIENT operates a
                Hospital/Medical Facility and CLIENT desires that LHS shall
                provide online meeting place to communicate with healthcare
                professionals.
              </p>

              <p className="mb-3">
                {" "}
                NOW THEREFORE, in consideration of the mutual promises and
                covenants between LHS and CLIENT, the Parties hereby agree:
              </p>

              <b>1. TERM</b>
              <p className="mb-3">
                {" "}
               The term of this Agreement will commence on the date of the last
                signature and will continue for three (3) years unless
                terminated prior thereto in accordance with the terms of this
                Agreement. If neither Party terminates pursuant to the terms
                herein, this agreement shall be automatically renewed for
                increment of additional (1) year periods and shall not require a
                writing by either party hereto in order to extend the term
                hereof.
              </p>

              <b>2. TERMINATION</b>
              <p className="mb-3">
                Either Party may terminate this Agreement at any time. Said
                termination will not affect the rights or responsibilities
                subsequent to transactions occurring prior to the effective date
                of termination.
              </p>

              <b>3. PERSONNEL</b>
              <p className="mb-3">
                {" "}
               LINKHEALTHSTAFF shall provide CLIENT with access to healthcare
                staff that comply with all pertinent terms and conditions of
                licensure and credentials including, but not limited to, proof
                of current licensure, registration and or certification (if
                applicable).
              </p>
              <Button
                className="logIn_button mt-5 !font-inter h-[58px] text-base font-semibold
            "
                onClick={props.handleCloseInstructions}
              >
                 Continue
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HospSignUp_3;
